import { Injectable } from "@angular/core";
import { AddNewAddressService } from "../../service/add-new-address.service";
import { LocationPayload, UpdateLocationPayload } from "../../components/list-addresses/interfaces/addresses-user.interface";
import { AuthService } from "../../../../../core/service/auth.service";
import { ListAddressesUserService } from "../../components/list-addresses/service/list-addresses-user.service";
import { LoaderMinimalGeneralService } from "../../../../components/loader-minimal-general/service/loader-minimal-general.service";
import { ModalViewLocationService } from "../../service/modal-view-location.service";
import { NotificationsService } from "../../../notifications/service/notifications.service";

@Injectable({
  providedIn: 'root'
})
export class FormSaveAddressService {
  private location: LocationPayload = {
    full_address: "",
    latitude: "",
    longitude: "",
    ua_id: 0,
    reference: "",
    name: ""
  }
  full_address: string = "";
  latitude: string = "";
  longitude: string = "";
  reference: string = "";
  name: string = "";
  ua_id: number = 0;

  constructor(private addNewAddressService: AddNewAddressService,
    private authService: AuthService,
    private listAddressService: ListAddressesUserService,
    private loaderService: LoaderMinimalGeneralService,
    public modalViewLocationService: ModalViewLocationService,
    private notificationsService: NotificationsService
  ) {


  }



  saveLocation() {
    if (this.authService.isLoggedIn()) {
      this.ua_id = this.authService.getUser()?.ua_id!;
      this.location = {
        full_address: this.full_address,
        latitude: this.latitude,
        longitude: this.longitude,
        ua_id: this.ua_id,
        reference: this.reference,
        name: this.name
      }
      if(!this.modalViewLocationService.isEditMode){
        this.saveRequest();
      }else{
        this.updateRequest();
      }
      
    }
  }

  saveRequest(){
    this.addNewAddressService.saveAddress(this.location).subscribe({
        next: (response) => {
          // console.log('location', this.location);
          // console.log('Respuesta del servidor:', response);

          // Emitir evento para recargar las direcciones
          this.listAddressService.refreshAddresses();
          // Ocultar el loader cuando la operación se complete con éxito
          this.loaderService.hideLoader();
          this.notificationsService.addNotification({
            message: response.message,
            type: "success",
            duration: 5000
          });
          this.modalViewLocationService.showMap(false);
        },
        error: (error) => {
          console.error('Error al enviar la solicitud:', error);
          // Ocultar el loader en caso de error
          this.loaderService.hideLoader();
          this.modalViewLocationService.showMap(false);
        }
      })
  }

  updateRequest(){
    let locationUpdate=(this.location as UpdateLocationPayload)
    locationUpdate.id_address=this.modalViewLocationService.editableAddress.ad_id;
    this.addNewAddressService.updateAddress(locationUpdate).subscribe({
        next: (response) => {
          // console.log('location', this.location);
          // console.log('Respuesta del servidor:', response);
          this.notificationsService.addNotification({
            message: response.message,
            type: "success",
            duration: 5000
          });
          // Emitir evento para recargar las direcciones
          this.listAddressService.refreshAddresses();
          // Ocultar el loader cuando la operación se complete con éxito
          this.loaderService.hideLoader();
          this.modalViewLocationService.showMap(false);
        },
        error: (error) => {
          console.error('Error al enviar la solicitud:', error);
          // Ocultar el loader en caso de error
          this.loaderService.hideLoader();
          this.modalViewLocationService.showMap(false);
        }
      });
      this.modalViewLocationService.setEditMode(false);
  }


}

